import {Col, Form, Input, message, Radio, Row, Select} from "antd";
import {useEffect, useState} from "react";
import Validation from "../../../util/Validation";
import {DropdownListDto} from "../../../dto/DropdownListDto";
import {ALPHANUMERIC_AND_NUMBER_VALIDATION, COMMON_DROPDOWN, PARAMETER_LIST} from "../../../util/Constants";
import {CustomerDto} from "../../../dto/CustomerDto";
import {InputDropdownParameterDto} from "../../../dto/InputDropdownParameterDto";
import customerService from "../../../service/customerService";
import {MSG_FAILED_TO_FETCH_COMMON_DROPDOWN_TYPES_ERROR} from "../../../util/Messages";
import ErrorHandler from "../../../util/ErrorHandler";
import TextArea from "antd/es/input/TextArea";
import {IncomeDetailDto} from "../../../dto/IncomeDetailDto";
import CommonFunction from "../../../util/CommonFunction";


interface InvestmentInformationProps {
    customerMstDto: CustomerDto
}


const InvestmentInformation = (props: InvestmentInformationProps) => {
    const [form] = Form.useForm();

    const [investmentObjective, setInvestmentObjective] = useState<DropdownListDto[]>([]);
    const [sourcesOfFunds, setSourcesOfFunds] = useState<DropdownListDto[]>([]);
    const [annualIncome, setAnnualIncome] = useState<DropdownListDto[]>([]);
    const [isInvestmentObjRemark, setIsInvestmentObjRemark] = useState(false);
    const [isSourceOfFUndRemark, setIsSourceOfFUndRemark] = useState(false);

    useEffect(() => {
        getCommonDropdownList();
        setInitialValues(props.customerMstDto?.incomeDetail as IncomeDetailDto);
    }, []);

    const setInitialValues = (incomeDetail: IncomeDetailDto) => {

        setIsInvestmentObjRemark(incomeDetail.investmentObjectiveID == 8)
        setIsSourceOfFUndRemark(incomeDetail.sourceOfWealthId == 5)
        form.setFieldsValue(
            {
                tinNo: incomeDetail.tinNo,
                addressOfEmployer: incomeDetail.addressOfEmployer,
                natureOfBusiness: incomeDetail.natureOfBusiness,
                otherInvestmentObjective: incomeDetail.otherInvestmentObjective,
                otherSourceOfWealth: incomeDetail.otherSourceOfWealth,
                nameOfEmployer: incomeDetail.nameOfEmployer,
                occupation: incomeDetail.occupation,
                annualIncomeId: incomeDetail.annualIncomeId,
                sourceOfWealthId: incomeDetail.sourceOfWealthId,
                expectedFutureInvestmentAmount: CommonFunction.currencyFormat(incomeDetail.expectedFutureInvestmentAmount),
                initialInvestmentAmount: CommonFunction.currencyFormat(incomeDetail.initialInvestmentAmount),
                investmentObjectiveID: incomeDetail.investmentObjectiveID
            }
        )
    }
    const getCommonDropdownList = () => {
        const inputDropdownParameterDto: InputDropdownParameterDto[] = [
            {
                dropdownDataSourceId: COMMON_DROPDOWN.INVESTMENT_OBJECTIVE,
                findTextValue: "",
                parameterList: [PARAMETER_LIST.ACTIVE]
            },
            {
                dropdownDataSourceId: COMMON_DROPDOWN.SOURCE_OF_FUND,
                findTextValue: "",
                parameterList: [PARAMETER_LIST.ACTIVE]
            },
            {
                dropdownDataSourceId: COMMON_DROPDOWN.ANNUAL_INCOME,
                findTextValue: "",
                parameterList: [PARAMETER_LIST.ACTIVE]
            },
        ]
        loadCommonDropdownDataList(inputDropdownParameterDto);
    }
    const loadCommonDropdownDataList = (dropDownParameterDto: InputDropdownParameterDto[]) => {
        customerService.getCommonDropdownList(dropDownParameterDto).then(res => {
            if (res.data !== null) {

                let dropdownDataList = res.data.results.dropdownDataList;
                setInvestmentObjective(dropdownDataList[COMMON_DROPDOWN.INVESTMENT_OBJECTIVE])
                setSourcesOfFunds(dropdownDataList[COMMON_DROPDOWN.SOURCE_OF_FUND])
                setAnnualIncome(dropdownDataList[COMMON_DROPDOWN.ANNUAL_INCOME])

            } else {
                message.error(MSG_FAILED_TO_FETCH_COMMON_DROPDOWN_TYPES_ERROR).then();
            }
        }, (reason) => {
            ErrorHandler.handleError(reason);
        })
    }

    return (
        <div>
            <Form
                className='form-input income-value-limit-styles'
                layout={"vertical"}
                form={form}
                disabled={true}
            >
                <Row gutter={[32, 0]}>

                    <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                        <Form.Item
                            label="Investment Objective"
                            name={"investmentObjectiveID"}>
                            <Select placement='bottomLeft' listHeight={180}
                                    placeholder={"Please select investment objective"}
                                    getPopupContainer={(trigger: { parentNode: any; }) => trigger.parentNode}
                                    style={{width: '100%'}}
                                    options={investmentObjective}
                            />
                        </Form.Item>
                        {
                            isInvestmentObjRemark ?
                                <Form.Item
                                    label="Other Investment Objective"
                                    name={"otherInvestmentObjective"}>
                                    <Input placeholder={"Enter other investment objective"}/>
                                </Form.Item> : ''
                        }
                        <Form.Item
                            label="Initial Investment Amount (LKR)"
                            name={"initialInvestmentAmount"}>

                            <Input maxLength={15}
                                   step="0.00"
                                   placeholder={"Enter initial investment amount"}/>

                        </Form.Item>
                        <Form.Item
                            label="Expected Future Investment Amount (LKR)"
                            name={"expectedFutureInvestmentAmount"}>

                            <Input maxLength={15}
                                   placeholder={"Enter expected future investment amount"}/>

                        </Form.Item>
                        <Form.Item
                            label="Source of Your Wealth"
                            name={"sourceOfWealthId"}>
                            <Select placement='bottomLeft' listHeight={180}
                                    placeholder={"Please select source(s) of funds"}
                                    getPopupContainer={(trigger: { parentNode: any; }) => trigger.parentNode}
                                    style={{width: '100%'}}
                                    options={sourcesOfFunds}
                            />
                        </Form.Item>
                        {
                            isSourceOfFUndRemark ?
                                <Form.Item
                                    label="Other Source of Funds"
                                    name={"otherSourceOfWealth"}
                                >
                                    <Input placeholder={"Enter other source of funds"}/>
                                </Form.Item> : ''
                        }
                        <Form.Item
                            label="Annual Income"
                            name={"annualIncomeId"}>
                            <Radio.Group>
                                <Row gutter={[2, 12]}>
                                    {annualIncome.map((data: DropdownListDto) => {
                                        return (<>
                                            <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
                                                <Radio value={data.value}>{data.label}</Radio>
                                            </Col>
                                        </>)
                                    })}
                                </Row>
                            </Radio.Group>
                        </Form.Item>

                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                        <Form.Item
                            name={"occupation"}
                            label="Occupation/ Position Held">
                            <Input placeholder={"Enter occupation/position held"}/>
                        </Form.Item>
                        <Form.Item
                            label="Name of the Employer"
                            name={"nameOfEmployer"}>
                            <Input placeholder={"Enter name of the employer"}/>
                        </Form.Item>
                        <Form.Item
                            label="Nature of Business"
                            name={"natureOfBusiness"}>
                            <Input placeholder={"Enter nature of business"}/>
                        </Form.Item>
                        <Form.Item
                            label="Address of Employer/ Businesses"
                            name={"addressOfEmployer"}>
                            <TextArea placeholder={"Enter address of employer/ businesses"}/>
                        </Form.Item>
                        <Form.Item
                            label="Taxpayer Identification Number (TIN)"
                            name={"tinNo"}
                            onKeyPress={Validation.alphanumericAndNumbers}
                            rules={[{
                                max: 12,
                                message: 'The maximum length is 12 characters'
                            },
                                {
                                    pattern: ALPHANUMERIC_AND_NUMBER_VALIDATION,
                                    message: 'These special characters are not allowed'
                                }
                            ]}>
                            <Input style={{width: '100%'}}
                                   placeholder={"Enter taxpayer identification number (TIN)"}/>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>

        </div>
    )
}
export default InvestmentInformation